import { ColourGroup } from '../models/colour-group.model';
import { MetricItem } from '../models/metric-item.model';

export function extractMetrics(colourGroups: ColourGroup[]): MetricItem[] {
    return colourGroups?.reduce<MetricItem[]>((acc, group) => {
        if (group.metrics != null) {
            acc.push(...group.metrics);
        }
        return acc;
    }, []);
}
